import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchIncidents(filters = {}) {
  const params = new URLSearchParams();
  if (filters.type) params.append('type', filters.type);
  if (filters.severity) params.append('severity', filters.severity);
  if (filters.status) params.append('status', filters.status);
  if (filters.affectedUserId) params.append('affectedUserId', filters.affectedUserId);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);

  const res = await apiFetch(`${API_BASE}/admin/incident?${params}`);
  return res.json();
}

export async function getIncidentStats() {
  const res = await apiFetch(`${API_BASE}/admin/incident/stats`);
  return res.json();
}

export async function updateIncident(incidentId, updates) {
  const res = await apiFetch(`${API_BASE}/admin/incident/${incidentId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  });
  return res.json();
}

export async function exportIncidentsCsv(from = null, to = null) {
  const params = new URLSearchParams();
  if (from) params.append('from', from);
  if (to) params.append('to', to);

  const res = await apiFetch(`${API_BASE}/admin/incident/export/csv?${params}`);

  if (!res.ok) {
    throw new Error('Failed to export incidents');
  }

  return res.blob();
}
